<template>
  <v-layout row justify-center>
    <v-dialog v-model="showColorForm" max-width="600px">
      <v-form>
        <v-card class="modern-modal">
          <div class="modal-head">
            <div class="modal-head-icon"><v-icon color="white">palette</v-icon></div>
            <span class="modal-head-title">Alterar Cor</span>
          </div>
          <v-card-text>
            <div v-show="loading" class="text-xs-center">
              <v-progress-circular
                indeterminate
                v-bind:color="color"
              ></v-progress-circular>
            </div>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <label for="favcolor">Selecione uma cor: </label>
                  <input
                    v-model="newColor"
                    type="color"
                    id="favcolor"
                    name="favcolor"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <!--  <p>Color select: {{ color }}</p> -->
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showChangeColorForm"
              >Fechar</v-btn
            >
            <v-btn
              v-if="this.color === null || partner === 'establishment'"
              color="primary"
              @click="sendColor"
              >Enviar</v-btn
            >
            <v-btn v-else color="primary" @click="sendColor">Enviar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "colorForm",
  data: () => ({
    newColor: "",
  }),
  created() {},
  computed: {
    ...mapGetters({
      showColorForm: "account/showColorForm",
      loading: "account/loading",
      color: "account/color",
      partner: "account/partner",
    }),
  },
  watch: {
    // Watchers removidos para evitar conflitos com computed properties
  },
  methods: {
    showChangeColorForm() {
      this.$store.dispatch("account/showColorForm", false);
    },
    sendColor() {
      this.$store.dispatch("account/sendColor", this.newColor);
    },
  },
};
</script>
